import { Base, Component } from '@/vue-property-decorator'
import { BrowserType, getBrowserType } from '../../const'
import {
  GlobalEventActions,
  GlobalEventActionsTypeEnum
} from '@/context/events'
import { GlobalEvents } from '@/context'
import { Modal } from '@/plugins/ant-design-vue/tsx-support'
import { deleteSearchParamsByURL } from '@/utils/Tool'
import { getGameOsType } from '@/views/game/utils'
import { getSaveAddress } from '@/api/task'
import { osType } from '@/views/game/consts'
import { supportShortcut } from '../../utils'
import { useEventStore } from '@/views/event/store'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import { useSaveShortcutStore } from '../../store'
import { windowConfig } from '@/utils/window'
import { windowOpen } from '@/utils/business-utils'
import ModalCloseIcon from '@/components/modal-close-icon'
import style from './style.module.scss'
const isSupportShortcut = supportShortcut()
interface State {
  browserType: BrowserType
}

/**
 * 一个引导用户“添加快捷方式到桌面”的组件
 * 目前测试中有该功能的浏览器有，ios的safari，
 * 安卓的chrome、Firefox、edge、opera、三星浏览器（可以看成火狐）、DuckDuckGO、Naver、
 * Hi Browser、Brave浏览器（"更多"按钮在右下角）、X浏览器（"更多"按钮在右上角）
 * 其中安卓中的(Brave浏览器、X浏览器)直接封装了chrome，无法分辨是(Brave浏览器、X浏览器)还是chrome
 * 注意：目前除了这几个浏览器，其他浏览器都不能实现“添加快捷方式到桌面”
 */
@Component<GuildSaveShortcut>({ name: 'GuildSaveShortcut' })
export default class GuildSaveShortcut extends Base<State> {
  eventStore = useEventStore()
  state: State = {
    browserType: getBrowserType()
  }

  /**
   * 系统
   */
  protected get OS() {
    return getGameOsType()
  }

  /**
   * “更多-添加到主屏幕按钮位置”
   */
  protected get addToScreenPosition() {
    let isBottom = false
    let isTopRight = false
    const browserType = this.state.browserType
    if (this.OS === osType.IOS && browserType === BrowserType.IsSafari) {
      isBottom = true
    } else {
      isTopRight = true
    }
    return {
      isTopRight,
      isBottom
    }
  }

  created(): void {
    GlobalEvents.subscribe(this.handleAddToHomeScreen)
  }

  beforeDestroy() {
    GlobalEvents.unsubscribe(this.handleAddToHomeScreen)
  }

  /**点击安装h5桌面快捷方式 */
  private handleAddToHomeScreen(action: GlobalEventActions) {
    if (
      action.type === GlobalEventActionsTypeEnum.PWA_INSTALL &&
      isSupportShortcut
    ) {
      this.addToHomeScreen()
    }
  }

  //创建URL参数
  protected async createSaveAddress() {
    const { hasLogined } = useMainStore()
    if (hasLogined) {
      const saveUrlUuid = await getSaveAddress()
      this.$router.replace({
        name: this.$route.name!,
        params: this.$route.params,
        query: {
          ...this.$route.query,
          saveUrlUuid
        }
      })
    }
  }

  /**
   * 安装成功回调
   */
  protected handlerPwaInstalled() {
    if (this.isKeptAlive) {
      return
    }
    const { setHasInstallPwaSuccess } = useSaveShortcutStore()
    setHasInstallPwaSuccess(true)
    this.setNoSaveShortcutTip()
    window.removeEventListener('appinstalled', this.handlerPwaInstalled)
  }

  /**
   * 保存快捷方式
   */
  protected async addToHomeScreen() {
    /**
     * 添加桌面快捷方式，如果在马甲包，或者极速包中,开窗处理，
     * 备注：之前的马甲包和极速包有可能是地址栏中带有WgPackage=com.example.myapplication，会被当前马甲包
     */
    if (
      windowConfig.isWgPackage ||
      !!windowConfig.speedPackageConfig?.isSpeedPackae
    ) {
      // 从马甲包跳转到浏览器，需要下掉马甲包的相关参数
      const urlByDeleteSearchParamByWgPackage = deleteSearchParamsByURL([
        'isWgPackage',
        'WgPackage'
      ])
      // 极速包跳转到浏览器，需要下掉极速包的相关参数
      const urlByDeleteSearchParamBySpeedPackage = deleteSearchParamsByURL(
        ['SpeedPackaeInit'],
        urlByDeleteSearchParamByWgPackage
      )
      windowOpen(urlByDeleteSearchParamBySpeedPackage)
      return
    }
    const { setShowSaveShortCutGuide } = this.eventStore
    GlobalEvents.dispatch({
      type: GlobalEventActionsTypeEnum.SAVE_SHORTCUT_SUCCESSS
    })

    /**
     * @description 场景分析
     * 1. 正常的设备，在window上面挂有onbeforeinstallprompt事件属性，并且能够通过window监听到该事件，那么就能够正常的安装成功
     * 成功之后hasInstallPwaSuccess属性为true（将该属性持久话）确保刷新页面后还能够进入pwa
     * useMainStore().installPrompt 为false
     *
     * 2. 非正常设备（类似于chrome110, 安卓版本13, 三星galaxy a14），该window挂有onbeforeinstallprompt事件属性，监听不到beforeinstallprompt事件
     * hasInstallPwaSuccess 属性为false
     *  useMainStore().installPrompt 为false，
     *
     * 3. 正常设备安装了h5桌面快捷方式，然后删除了h5桌面快捷方式，那么再次进入的话还是会再次正常安装  useMainStore().installPrompt = true
     *
     */
    if ('onbeforeinstallprompt' in window) {
      if (!useMainStore().installPrompt) {
        const { hasInstallPwaSuccess } = useSaveShortcutStore()
        if (hasInstallPwaSuccess) {
          windowOpen(window.location.href)
          return
        }
      }
    }
    if (this.OS == osType.Android) {
      if (!!useMainStore().installPrompt) {
        try {
          window.addEventListener('appinstalled', this.handlerPwaInstalled)
          await useMainStore().installPrompt?.prompt?.()
        } catch (err) {}
        return
      }
    }
    setShowSaveShortCutGuide(true)
  }

  protected setNoSaveShortcutTip() {
    const { setHasClickButtonSaveShortCut } = useMainStore()
    setHasClickButtonSaveShortCut(true)
  }

  render() {
    const { setShowSaveShortCutGuide, showSaveShortCutGuide } = this.eventStore
    const { t } = useI18n()
    const onCancel = () => {
      const { setHasClickButtonSaveShortCut } = useMainStore()
      setHasClickButtonSaveShortCut(true)
      setShowSaveShortCutGuide(false)
    }
    const { siteConfig } = useMainStore()
    const { isTopRight, isBottom } = this.addToScreenPosition
    let stepImg1
    let stepImg2
    if (this.OS === osType.IOS) {
      stepImg1 = '/lobby_asset/common/web/home/img_ios_jc_1.png'
      stepImg2 = '/lobby_asset/common/web/home/img_ios_jc_2_zh.png'
    } else {
      stepImg1 = '/lobby_asset/common/web/home/img_android_jc_1.png'
      stepImg2 = '/lobby_asset/common/web/home/img_android_jc_2_zh.png'
    }
    return (
      <Modal.Tsx
        class={{
          [style.guideModal]: true,
          [style.isTopRightGuideModal]: isTopRight,
          [style.isBottomGuideModal]: isBottom
        }}
        centered={true}
        destroyOnClose={true}
        v-model={showSaveShortCutGuide}
        maskClosable={false}
        footer={null}
        onCancel={onCancel}
        closable={!isTopRight}
        width={'100%'}
        {...{
          directives: [
            {
              name: 'perfect-scrollbar',
              value: {
                el: (el: HTMLElement) => el.querySelector('.ant-modal-content')
              }
            }
          ]
        }}
      >
        <h1>
          {this.OS === osType.IOS
            ? t('lobby.saveShortcut.guideModalTitle')
            : t('lobby.saveShortcut.guideModalTitleAndriod')}
        </h1>
        <div class={style.guideContent}>
          <p>{t('lobby.saveShortcut.guideModalStep1')}</p>
          {this.OS === osType.IOS ? (
            <div class={style.iosImgOne}>
              <my-img src={stepImg1} />
              <span>{t('lobby.saveShortcut.label4')}</span>
              <span>{t('lobby.saveShortcut.label5')}</span>
              <span>{t('lobby.saveShortcut.guideModalTitle')}</span>
              <span>{t('lobby.saveShortcut.label6')}</span>
            </div>
          ) : (
            <div class={style.androidImgOne}>
              <my-img src={stepImg1} />
              <span>{t('lobby.saveShortcut.label1')}...</span>
              <span>{t('lobby.saveShortcut.label2')}</span>
              <span>{t('lobby.saveShortcut.guideModalTitleAndriod')}</span>
              <span>{t('lobby.saveShortcut.label3')}</span>
            </div>
          )}
          <p class={style.text2}>{t('lobby.saveShortcut.guideModalStep2')}</p>
          {this.OS === osType.IOS ? (
            <div class={style.iosImgTwo}>
              <my-img src={stepImg2} />
              <span>{t('lobby.saveShortcut.cancle')}</span>
              <span>{t('lobby.saveShortcut.guideModalTitle')}</span>
              <span>{t('lobby.saveShortcut.add')}</span>
              <span>{document.title}</span>
              <span>{location.href}</span>
              <span>{t('lobby.saveShortcut.label7')}</span>
              {siteConfig?.siteAppIcon && <img src={siteConfig?.siteAppIcon} />}
            </div>
          ) : (
            <div class={style.androidImgTwo}>
              <my-img src={stepImg2} />
              <span>{t('lobby.saveShortcut.guideModalTitleAndriod')}</span>
              <span>{document.title}</span>
              <span>{t('lobby.saveShortcut.cancle')}</span>
              <span>{t('lobby.saveShortcut.add')}</span>
              {siteConfig?.siteAppIcon && <img src={siteConfig?.siteAppIcon} />}
            </div>
          )}
        </div>
        <my-img
          class={style.pointer}
          src={'/lobby_asset/common/web/home/pointer.png'}
        />
        <ModalCloseIcon
          v-show={isTopRight}
          close={() => {
            setShowSaveShortCutGuide(false)
          }}
        />
      </Modal.Tsx>
    )
  }
}
